module.exports = __webpack_public_path__ + "img/22.0d399025.svg";